import { useTranslations } from '@i18n/useLanguage'
import { MegaMenuLinks } from '../blocks/common'
import {
  faUsers,
  faHandshake,
  faScaleBalanced,
} from '@fortawesome/pro-solid-svg-icons'
import { MegaMenuGrid } from '../blocks/MegaMenuGrid'
import { TextLink } from '@app/components/core/link/TextLink'
import Column from '@app/components/layout/Column'

const AboutUsMenu = () => {
  const t = useTranslations().app.nav.megaMenu.aboutUsMenu

  return (
    <MegaMenuGrid
      columns={[
        {
          items: [
            {
              to: MegaMenuLinks.aboutUs,
              icon: faUsers,
              label: t.about.label,
              description: t.about.description,
              backgroundColor: 'var(--brand-tertiary)',
              children: (
                <Column
                  gap="1rem"
                  style={{ paddingLeft: '4rem', justifyContent: 'flex-end' }}
                >
                  <TextLink
                    size="small"
                    to={MegaMenuLinks.stewardOwnership}
                    containerStyle={{ textDecoration: 'none' }}
                  >
                    {t.about.links.stewardOwned}
                  </TextLink>
                  <TextLink
                    externalURL
                    target="_blank"
                    size="small"
                    to={MegaMenuLinks.joinUs}
                    containerStyle={{ textDecoration: 'none' }}
                  >
                    {t.about.links.joinUs}
                  </TextLink>
                  <TextLink
                    size="small"
                    to={MegaMenuLinks.contactUs}
                    containerStyle={{ textDecoration: 'none' }}
                  >
                    {t.about.links.contact}
                  </TextLink>
                </Column>
              ),
            },
          ],
        },
        {
          items: [
            {
              to: MegaMenuLinks.legal,
              icon: faScaleBalanced,
              label: t.legal.label,
              description: t.legal.description,
              backgroundColor: 'var(--palette-yellow-300)',
            },
            {
              to: MegaMenuLinks.aboutUs,
              icon: faHandshake,
              label: t.partner.label,
              backgroundColor: 'var(--palette-pink-200)',
              children: (
                <Column gap="1rem" style={{ paddingLeft: '4rem' }}>
                  <TextLink
                    size="small"
                    to={MegaMenuLinks.municipalities}
                    containerStyle={{ textDecoration: 'none' }}
                  >
                    {t.partner.links.municipalities}
                  </TextLink>
                  <TextLink
                    size="small"
                    to={MegaMenuLinks.experts}
                    containerStyle={{ textDecoration: 'none' }}
                  >
                    {t.partner.links.experts}
                  </TextLink>
                </Column>
              ),
            },
          ],
        },
      ]}
    />
  )
}

export default AboutUsMenu
